import { Injectable } from '@angular/core';
import { concat, Observable } from 'rxjs';
import { first, tap } from 'rxjs/operators';

import { CountryInterface } from '../data';
import { NormativeCountryApiRepository } from '../repositories/normative-country-api.repository';
import { NormativeCountryCacheRepository } from '../repositories/normative-country-cache.repository';
import { Transaction } from '../transaction/transaction';

@Injectable()
export class NormativeCountryProvider {
    constructor(
        private normativeCountryApiRepository: NormativeCountryApiRepository,
        private normativeCountryCacheRepository: NormativeCountryCacheRepository
    ) {}

    find(): Observable<Transaction<CountryInterface[]>> {
        return concat(
            this.normativeCountryCacheRepository.load(),
            this.normativeCountryApiRepository.load().pipe(
                tap((transaction) => {
                    if (transaction.isSuccess) {
                        this.normativeCountryCacheRepository.save(transaction.data).subscribe();
                    }
                })
            )
        ).pipe(first());
    }
}
